import { IWatrRequest } from '@nkr/models/index';
import { WageAndTravelReimbursementRequestStatus } from '@nkr/enums/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IWatrRequest,
    onCancelRequest: (requestId: number) => void
    onClose: () => void,
}

const getPendingAdditionalWeeks = (data: IWatrRequest): number[] => {
    if (!data || !data.requestWeeks) {
        return [];
    }
    return data.requestWeeks
        .filter(w =>
            w.status === WageAndTravelReimbursementRequestStatus.PendingApproval
            && w.weekRequested > 3)
        .map(w => w.weekRequested)
        .sort((a, b) => a - b);
};

const CancelRequest = (props: IProps) => {
    if (props.data == null)
        return null;

    const pendingAdditionalWeeks = getPendingAdditionalWeeks(props.data);

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Cancel for <strong>{props.data.firstName + ' ' + props.data.lastName}</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='alert alert-warning'>
                    Are you sure you wish to cancel this reimbursement request for <strong>{props.data.firstName + ' ' + props.data.lastName}</strong>?
                </div>
                {pendingAdditionalWeeks.length > 0 && (
                    <div className='alert alert-danger' style={{ marginBottom: 0 }}>
                        The following pending additional week{pendingAdditionalWeeks.length === 1 ? '' : 's'} will be automatically declined:
                        {' '}<strong>{pendingAdditionalWeeks.join(', ')}</strong>.
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="danger" onClick={() => props.onCancelRequest(props.data.id)}>Yes, Confirm Cancellation</Button>
                <Button onClick={props.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CancelRequest;
